import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { ParameterField } from '../../../../_common/platform/tsx/ParameterField';
import NumberField from '../../../../_common/platform/tsx/NumberField';
import SelectField, { createSelectFieldOptions } from '../../../../_common/platform/tsx/SelectField';
import * as FilterUtilities from '../../../../_common/platform/tsx/filtering/FilterUtilities';
import { IIntervals } from '../../../../_common/platform/ts/AqlUtility';
import * as Globalization from '../../../../_common/platform/ts/Globalization';
import { IAttributeTimePartOptions, TimePartControlType } from '../../../platform/tsx/filtering/Interfaces';
import { IValuesCollection } from '../../../platform/ts/appTheme';
import { themeVars } from '../../../../pdc-platform/src/ts/themes/themeConstants';

import { TIME_PART_TYPES } from '../../../platform/ts/ConfigurationConstants';

export class IntegerNumberSelect extends React.Component<
    {
        value: number;
        title: string;

        onChange(value: number): void;
    },
    {}
> {
    render() {
        return (
            <ParameterField title={this.props.title} clearable={false}>
                <NumberField value={this.props.value} integer={true} positive={true} onChange={this.props.onChange} />
            </ParameterField>
        );
    }
}

export default class TimePartOptions extends React.Component<
    {
        value: IAttributeTimePartOptions;
        intervals: IIntervals;
        theme: IValuesCollection;
        hideTimePartControlType?: boolean;
        hideYearOptions?: boolean;

        onChange?(value: IAttributeTimePartOptions): void;
        onTimePartStartMonthChange?(value: number): void;
    },
    {}
> {
    constructor(props) {
        super(props);
    }

    getValueCopy() {
        return this.props.value != null ? $.extend(true, {}, this.props.value) : {};
    }

    handleOnTimePartControlTypeChange = (value: string) => {
        const result = this.getValueCopy();

        result.timePartControlType = value as TimePartControlType;

        if (this.props.onChange != null) {
            this.props.onChange(result);
        }
    };

    handleOnMinYearChange = (value: number) => {
        const result = this.getValueCopy();

        result.minYear = value;

        if (this.props.onChange != null) {
            this.props.onChange(result);
        }
    };

    handleOnMaxYearChange = (value: number) => {
        const result = this.getValueCopy();

        result.maxYear = value;

        if (this.props.onChange != null) {
            this.props.onChange(result);
        }
    };

    handleTimePartStartMonthChange = (value: string) => {
        if (this.props.onTimePartStartMonthChange != null) {
            this.props.onTimePartStartMonthChange(parseInt(value));
        }
    };

    handleOnFiscalTimePartStartMonthClear = () => {
        if (this.props.onTimePartStartMonthChange != null) {
            this.props.onTimePartStartMonthChange(null);
        }
    };

    render() {
        const { intervals } = this.props;

        if (intervals == null) {
            return null;
        }

        const { minYear, maxYear, timePartControlType } = this.props.value;
        const { timePart } = intervals;

        const content: React.JSX.Element[] = [];

        if (this.props.hideTimePartControlType !== true) {
            if (timePart != null && timePart !== TIME_PART_TYPES.MILLISECOND) {
                content.push(
                    <ParameterField key="time-part-control-type" title={'Time Part Display'} clearable={false}>
                        <SelectField
                            value={timePartControlType != null ? timePartControlType.toString() : 'dropdown'}
                            onChange={this.handleOnTimePartControlTypeChange}
                        >
                            <option key="dropdown" value={'dropdown'}>
                                {'Dropdown'}
                            </option>

                            <option key="list" value={'list'}>
                                {'List'}
                            </option>
                        </SelectField>
                    </ParameterField>
                );
            }
        }

        if (this.props.hideYearOptions !== true && FilterUtilities.isFullYearTimePart(timePart)) {
            content.push(
                <IntegerNumberSelect
                    key="minYear"
                    value={minYear || 2000}
                    title={'Start Year'}
                    onChange={this.handleOnMinYearChange}
                />
            );

            content.push(
                <IntegerNumberSelect
                    key="maxYear"
                    value={maxYear || 2050}
                    title={'End Year'}
                    onChange={this.handleOnMaxYearChange}
                />
            );
        }

        if (FilterUtilities.isFiscalTimePart(timePart)) {
            const months = Globalization.getMonths();
            const monthsOptions = createSelectFieldOptions(months);
            const themeTimePartStartMonth = this.props.theme[themeVars.fiscalFirstMonth];
            const defaultValue = (themeTimePartStartMonth || 1).toString();

            let timePeriodStartMonth: string;
            let inherited = false;

            if (intervals.timePeriodStartMonth == null) {
                //EVG 01.06.2020: Obsolete. Drop it.
                timePeriodStartMonth = (intervals as any).fiscalTimePartStartMonth;

                if (timePeriodStartMonth != null) {
                    timePeriodStartMonth = timePeriodStartMonth.toString();
                } else {
                    if (themeTimePartStartMonth != null) {
                        timePeriodStartMonth = themeTimePartStartMonth.toString();
                        inherited = true;
                    } else {
                        timePeriodStartMonth = defaultValue;
                    }
                }
            } else {
                timePeriodStartMonth = intervals.timePeriodStartMonth.toString();
            }

            //SelectField works with string values.
            content.push(
                <ParameterField
                    key="fiscal-start-month"
                    title={'Fiscal Start Month'}
                    clearable={true}
                    showInheritedIcon={inherited}
                    defaultValue={defaultValue}
                    onClear={this.handleOnFiscalTimePartStartMonthClear}
                >
                    <SelectField value={timePeriodStartMonth} onChange={this.handleTimePartStartMonthChange}>
                        {monthsOptions}
                    </SelectField>
                </ParameterField>
            );
        }

        if (content.length === 0) {
            return null;
        }

        return <div className="time-part-options">{content}</div>;
    }
}
